


















import { Component, Prop } from 'vue-property-decorator';
import 'devextreme/data/odata/store';
import { Inject } from '@/core/helpers/vue-inversify-decorator';
import DataSource from 'devextreme/data/data_source';
import { Table, TableOptions, getTableCaption } from '@/core/components/table';
import { Page } from '@/core/components/controls';
import {
    FetchServiceContract,
    CONTRACTS,
    EventsServiceContract,
    Events
    } from '@/core/contracts';
import { lookupField } from '@/core/helpers';
import { localize } from '../../core/filters';
import { StructuredResult, ConsumptionsSubPacks } from '@/dto';
import { ConsumptionsPageArgs } from './types';
import ConsumptionsRoutesTable from './ConsumptionsRoutesTable.vue';
import { ContextsState } from '@/store';

@Component({
    components: {
        ConsumptionsRoutesTable,
        TableOptions,
    },
})
export default class ConsumptionsRoutesPage extends Page {
    @Prop({ default: () => ({}) })
    public args!: ConsumptionsPageArgs;

    public table: Table | null = null;
    public tableKey: string = 'pack-route-in-details-control';

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.EventsService)
    private _eventsService?: EventsServiceContract;

    public setTable(table: Table): void {
        this.table = table;
    }

    public get dataSource(): DataSource {
        return new DataSource({
            key: 'id' as keyof ConsumptionsSubPacks,
            load: this.load,
        });
    }

    public async mounted() {
        this._eventsService!.on(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public async beforeDestroy() {
        this._eventsService!.off(
            Events.ProcessingFinished,
            this.onProcessingFinished
        );
    }

    public get tableName(): string {
        return getTableCaption(this.tableKey);
    }

    private onProcessingFinished({ contextId }: any) {
        if (Number(ContextsState.currentContextId) === Number(contextId)) {
            this.table!.refresh();
        }
    }

    private async load() {
        const packId = this.args.packId;
        const detailId = this.args.detailId;
        const currentContextId =
            this.args.contextId || ContextsState.currentContextId;
        const url = `/contexts/${currentContextId}/microeconomics/packs/${packId}/in?details=${detailId}`;
        const data = await this._fetchService!.get<
            StructuredResult<ConsumptionsSubPacks>
        >(url);
        if (!data) {
            return {
                data: [],
                totalCount: 0,
            };
        }
        this.transform(data);
        const items = data.items || [];

        return {
            data: items,
            totalCount: items.length,
        };
    }

    private transform(data: StructuredResult<ConsumptionsSubPacks>) {
        if (!(data && data.items)) {
            return;
        }
        for (let index = 0; index < data.items.length; index++) {
            const item = data.items[index];
            item.id = index;

            // for excel print
            const anyPack = item as any;
            anyPack.packId_isActive = !!anyPack.packId;

            lookupField(item, 'product', data.products);
            lookupField(item, 'owner', data.owners);
            lookupField(item, 'project', data.projects);
            lookupField(item, 'object', data.objects);

            item.volume = item.quantity / item.product.displayDenominator;
            item.event = localize(`EventType_${item.event}`);
        }
    }
}
